/**
 * JSON Schema for the playbackInfo object.
 *
 * http://json-schema.org/
 */
export default {
  id: "/Playback",
  type: "object",
  properties: {
    currentBitrate: { type: "string" },
    currentTime: { type: "number" },
    vualtoToken: { type: "string" },
    titleId: { type: "string" },
    releasePid: { type: "string" },
    releaseUrl: { type: "string" },
    manifestUrl: { type: "string" },
    availableBandwidth: { type: "string" },
    audioLang: { type: "string" },
    subsLang: { type: "string" },
    sessionId: { type: "number" },
    playerErrorDump: { type: "object" },
    quality: { type: "string" }
  }
};
